import React, { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { NewView } from '@app/components/NewView'
import { HelpPane } from '@app/components/HelpPane'
import { TrackSelectPane } from '@app/components/TrackSelectPane'
import { rootStoreContext } from '@app/components/App'
import classnames from 'classnames'

export const Container = observer(() => {
  const rootStore = useContext(rootStoreContext)

  return (
    <div className="relative">
      {rootStore.helpOpen && <HelpPane />}
      {rootStore.trackSelectOpen && <TrackSelectPane />}
      <NewView />
      <div
        className={classnames(
          'fixed lg:absolute bg-white z-30 w-full h-full top-0 left-0 flex justify-center items-center text-2xl',
          rootStore.initialized ? 'opacity-0' : 'opacity-100',
          rootStore.initialized ? 'pointer-events-none' : 'pointer-events-auto'
        )}
      >
        <div>Loading...</div>
      </div>
    </div>
  )
})
